import { render } from "./section_1.vue?vue&type=template&id=ca1b7f04"
import script from "./section_1.vue?vue&type=script&lang=js"
export * from "./section_1.vue?vue&type=script&lang=js"

import "./section_1.vue?vue&type=style&index=0&id=ca1b7f04&lang=css"
script.render = render

export default script